<script>
    import article from "../../stores/article.js";
    import Preview from "./Preview.svelte";

    export let window;
</script>

<Preview store={article} unit="article" sourceTitle="Wikipedia" {window} />
